import Submit from '~/components/button/Submit';
import Divide from '~/components/Divide';
import Form from '~/components/Form';
import { CheckboxPrimitive } from '~/components/form-controls/Checkbox';
import Field from '~/components/form-controls/Field';
import Page from '~/components/layout/page/Page';
import LineItem from '~/components/LineItem';
import { useActionResult, useLoaderData } from './shippingClaimItems';

export default function ShippingClaimItemsPage() {
  const { items, selectedItemIds } = useLoaderData();
  const actionResult = useActionResult();

  return (
    <Page.Root title="Which items were affected?">
      <Form>
        <fieldset aria-describedby="field-message">
          <legend className="sr-only">Order Items</legend>
          <Divide>
            {items.map((item) => (
              <Field.Root
                className="flex flex-row items-center gap-4"
                key={item.id}
              >
                <Field.Label
                  className="flex w-full items-center justify-between gap-4"
                  htmlFor={`${item.id}`}
                >
                  <span className="sr-only">{item.name}</span>
                  <div aria-hidden className="flex-1">
                    <LineItem
                      variant="small"
                      name={item.name ?? 'N/A'}
                      imgSrc={item.imgUrl}
                      quantity={item.quantity}
                      options={item.optionsFromPlatform}
                    />
                  </div>
                  <CheckboxPrimitive
                    id={`${item.id}`}
                    name="items"
                    value={item.id}
                    defaultChecked={
                      selectedItemIds.includes(item.id) || items.length === 1
                    }
                  />
                </Field.Label>
              </Field.Root>
            ))}
          </Divide>
        </fieldset>
        {actionResult?.ok === false && (
          <Field.ErrorText>{actionResult.message}</Field.ErrorText>
        )}
        <Submit>Next</Submit>
      </Form>
    </Page.Root>
  );
}
